import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL_SANDBOX, GIFT_CARD_STORE } from '../../../Constants/Config';

export const fetchGiftCards = createAsyncThunk(
  'giftCards/fetchGiftCards',
  async (data, { rejectWithValue }) => {
    const { customer_id, merchant_id } = data;
    try {
      // const formData = new FormData();
      // formData.append('user_id', customer_id);
      // formData.append('merchant_id', merchant_id);

      const payload = {
        user_id: customer_id,
      };
      const response = await axios.post(
        `${BASE_URL_SANDBOX}${GIFT_CARD_STORE}`,
        payload,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      );

      if (response.data.status) {
        // Filter out gift cards with 0 balance
        const filteredData = (response.data.gc_data || []).filter(
          (item) => parseFloat(item?.balance || 0) > 0
        );
        return filteredData;
      } else {
        return rejectWithValue('Failed to fetch gift cards');
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

const giftCardSlice = createSlice({
  name: 'giftCards',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearGiftCards: (state) => {
      state.data = [];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGiftCards.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGiftCards.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchGiftCards.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearGiftCards } = giftCardSlice.actions;
export default giftCardSlice.reducer;
